import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import dayjs from 'dayjs'
import DashboardWrapper from '../../Dashboard/components/DashboardWrapper'
import Table from '../../../components/Table'
import Button from '../../../components/Button'
import Loader from '../../../components/Loader'
import { handleOpenModal } from '../../../utils'
import { PRIVATE_ROUTES } from '../../../Routes/routes'
import { getContractDocuments } from '../../../services/NewServicesCompnay'
import { TAGS } from '../../../services/Tags'
import CreateContractDocumentModal from './components/CreateContractDocumentModal'

const parseBoolText = (value) => String(value).toLowerCase() === 'true'

const ContractDocuments = () => {
  const navigate = useNavigate()

  const { data: documents = [], isLoading } = useQuery(
    [TAGS.contract_documents],
    getContractDocuments,
    {
      select: (data) => {
        const list = data?.res?.documents
        return Array.isArray(list) ? list : []
      },
    }
  )

  const HeadComponent = () => (
    <tr className="text-on-bg-primary">
      <th scope="col">Nombre</th>
      <th scope="col">Impuestos</th>
      <th scope="col">Monto</th>
      <th scope="col">Meses</th>
      <th scope="col">Estado</th>
      <th scope="col">Creado</th>
      <th scope="col" className="text-center">
        Acciones
      </th>
    </tr>
  )

  const BodyComponent = () =>
    documents.map((document) => {
      const extra = document?.extra ?? {}

      return (
        <tr key={document.id} className="cursor-pointer">
          <td>{document.name}</td>
          <td>
            {extra.taxes ?? '—'}%
            {parseBoolText(extra.taxApplies) ? '' : ' (no aplica)'}
          </td>
          <td>{extra.amount ?? '—'}</td>
          <td>
            {parseBoolText(extra.indefiniteTime) ? 'Indefinido' : extra.months ?? '—'}
          </td>
          <td>
            <span
              className="badge"
              style={{
                background: document.active ? '#dcfce7' : '#fee2e2',
                color: document.active ? '#166534' : '#991b1b',
              }}
            >
              {document.active ? 'Activo' : 'Inactivo'}
            </span>
          </td>
          <td>
            {document.created_at
              ? dayjs(document.created_at).format('DD/MM/YYYY')
              : '—'}
          </td>
          <td className="text-center">
            <Button
              className="btn-sm"
              onClick={() =>
                navigate(
                  PRIVATE_ROUTES.master_contract_document_detail.replace(
                    ':id',
                    String(document.id)
                  )
                )
              }
            >
              Ver detalle
            </Button>
          </td>
        </tr>
      )
    })

  return (
    <DashboardWrapper showTitle title="Contratos">
      <CreateContractDocumentModal />

      <div className="d-flex justify-content-end align-items-center mb-3">
        <Button
          onClick={() => handleOpenModal({ id: 'create-contract-document-modal' })}
        >
          Crear contrato
        </Button>
      </div>

      {isLoading ? (
        <Loader />
      ) : documents.length === 0 ? (
        <p className="text-on-bg-secondary mb-0">No hay contratos registrados.</p>
      ) : (
        <Table BodyComponent={BodyComponent} HeadComponent={HeadComponent} />
      )}
    </DashboardWrapper>
  )
}

export default ContractDocuments
